export const LogoMark = ({ className = "h-11 w-10" }) => (
  <svg viewBox="0 0 40 48" className={className} aria-hidden="true">
    <path d="M4 47V22a16 16 0 0 1 32 0v25" fill="none" stroke="#B0703F" strokeWidth="1.4" />
    <text x="20" y="40" textAnchor="middle" fontFamily="Cinzel, Georgia, serif" fontSize="21" fill="currentColor">
      P
    </text>
    <circle cx="20" cy="12" r="2.2" fill="#D9A21B" />
  </svg>
);

export const Logo = ({ light = false, className = "" }) => (
  <span className={`flex items-center gap-3 ${light ? "text-ivory" : "text-navy"} ${className}`}>
    <LogoMark />
    <span className="font-brand text-[1.6rem] leading-none tracking-[0.08em]">
      PERFERO<sup className="ml-0.5 text-[0.5rem] align-super">®</sup>
    </span>
  </span>
);
